import axios from "axios";

const FINCART_ORDER_ID_REGEX = /^[a-f\d]{24}$/i;
export const FINCART_AWB_ELIGIBLE_STATUSES = ["New", "Pending Confirmation"];

export function isFincartOrder(order) {
  return Boolean(
    order?.fincartId
    || order?.vendor?.shippingService === "Fincart"
    || (order?.courierTrackingId && !order?.bostaTrackingId && !order?.shipbluTrackingId)
  );
}

export function isFincartAwbEligible(order) {
  return Boolean(
    order?.fincartId
    && FINCART_ORDER_ID_REGEX.test(order.fincartId)
    && FINCART_AWB_ELIGIBLE_STATUSES.includes(order?.status)
  );
}

export function parseAwbError(error, service) {
  const data = error?.response?.data;
  let message = error?.message;

  if (data instanceof ArrayBuffer) {
    try {
      const json = JSON.parse(new TextDecoder().decode(data));
      message = json.errors?.join(", ") || json.message || message;
    } catch (parseError) {
      // keep default message
    }
  } else if (data && typeof data === "object") {
    message = data.errors?.join(", ") || data.message || message;
  }

  if (service === "Fincart" && /invalid order id/i.test(message || "")) {
    return "Fincart AWB is only available for pending new orders. Use a New or Pending Confirmation order, or recreate it in Fincart.";
  }

  return message;
}

export async function downloadShippingAwbs({
  token,
  apiBasePath,
  service,
  trackingNumbers = [],
  fincartOrderIds = [],
  blinkOrderIds = [],
}) {
  const { data } = await axios.post(`${process.env.REACT_APP_API_BASE}/${apiBasePath}/orders/awb`, {
    service,
    trackingNumbers,
    fincartOrderIds,
    blinkOrderIds,
  }, {
    headers: {
      "x-access-token": token,
    },
    responseType: "arraybuffer",
  });

  return data;
}

export function groupOrdersForAwbPrinting(orders = []) {
  const fincartOrders = orders
    .filter((order) => isFincartAwbEligible(order))
    .map((order) => ({
      fincartId: order.fincartId,
      label: order.fincartCode || order.courierTrackingId || order.shopifyOrderNumber || order._id,
    }));

  const fincartOrdersMissingId = orders.filter((order) => {
    return isFincartOrder(order) && (!order.fincartId || !FINCART_ORDER_ID_REGEX.test(order.fincartId));
  });

  const fincartOrdersNotEligible = orders.filter((order) => {
    return order.fincartId
      && FINCART_ORDER_ID_REGEX.test(order.fincartId)
      && !FINCART_AWB_ELIGIBLE_STATUSES.includes(order.status);
  });

  return {
    shipbluOrders: orders
      .filter((order) => order.shipbluTrackingId && !order.fincartId && !order.bostaTrackingId && !order.blinkTrackingId)
      .map((order) => order.shipbluTrackingId),
    bostaOrders: orders
      .filter((order) => order.bostaTrackingId && !order.fincartId && !order.blinkTrackingId)
      .map((order) => order.bostaTrackingId),
    blinkOrders: orders
      .filter((order) => order.blinkId)
      .map((order) => ({ blinkId: order.blinkId, label: order.blinkTrackingId || order.shopifyOrderNumber || order._id })),
    fincartOrders,
    fincartOrdersMissingId,
    fincartOrdersNotEligible,
  };
}

export function getOrderAwbService(order) {
  if (order?.blinkId) {
    return "Blink";
  }
  if (order?.fincartId && FINCART_ORDER_ID_REGEX.test(order.fincartId)) {
    return "Fincart";
  }
  if (order?.bostaTrackingId) {
    return "Bosta";
  }
  if (order?.shipbluTrackingId) {
    return "ShipBlu";
  }
  return null;
}
